import { Controller } from "@hotwired/stimulus"
import { updateAvailable, activateUpdate } from "../field_update_state"

// Connects to data-controller="field-update-status" (the Sync page's own
// status card, app/views/field/sync/show.html.erb, beside "Sync now").
//
// Card #4859 pt 1, Scope B -- reads the same shared current-version state
// (field_update_state.js) as the Today/Places banner
// (field_update_banner_controller.js), so the two can never disagree about
// whether an update is waiting. No polling: field:update-available fires the
// instant the service worker's SW_UPDATED message lands (see
// field_service_worker.js's activate handler and application.js's handler).
export default class extends Controller {
  static targets = ["icon", "statusText", "subtext", "updateButton"]

  connect() {
    this._render()
    this._handler = () => this._render()
    window.addEventListener("field:update-available", this._handler)
  }

  disconnect() {
    window.removeEventListener("field:update-available", this._handler)
  }

  // "Update now" -- no gating, no safe-point detection (rejected by Jay and
  // Vanessa). activateUpdate() is a plain reload: Scope A already leaves the
  // new worker fully active, just not in control of this tab.
  update() {
    activateUpdate()
  }

  // -- private --

  _render() {
    if (!this.hasStatusTextTarget) return
    const available = updateAvailable()

    this.statusTextTarget.textContent = available ? "Update available" : "Up to date"
    this.subtextTarget.textContent = available
      ? "A new version is ready. Update when you're ready."
      : "You're running the latest version"
    this.updateButtonTarget.classList.toggle("hidden", !available)
    this.iconTarget.innerHTML = available ? this._updateIcon() : this._upToDateIcon()
  }

  _upToDateIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-emerald-500" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
      </svg>`
  }

  // Same arrow-path "update available" family as field/shared/_update_banner.
  _updateIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>`
  }
}
